import { Flex, Text, Image, Box } from "@chakra-ui/react";
import BgImage from "@/assets/bg-w.png";
import TitleHeader from "@/components/TitleHeader";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import { usdcInfo } from "@/constants/tokens";
import { formatAmount } from "@/utils/formatBalance";
import ReceiptTop from "./assets/receipt-top.png";
import ReceiptBottom from "./assets/receipt-bottom.png";
import { shortenAddress } from "@/utils";
import usePublicClient from "@/hooks/usePublicClient";
import dayjs from "dayjs";
import { unknownEmoji } from "@/utils/avatars";
import { getOrder, Order, Status } from "@/api/order";
import { useCurrencyExchange } from "@/hooks/useCurrencyExchange";

const WithdrawReceipt = () => {
  const { orderId } = useParams();
  const { txHash } = useParams();
  const navigate = useNavigate();
  const { usdToCurrency, currencyUnit } = useCurrencyExchange();
  const [_, setTxDetail] = useState<any>(null);
  const publicClient = usePublicClient();
  const [orderDetail, setOrderDetail] = useState<Order | null>(null);
  const isConfirmed = useMemo(() => {
    if (!orderDetail) return false;
    return orderDetail.status === Status.Completed;
  }, [orderDetail]);

  const getOrderDetail = async () => {
    try {
      const order = await getOrder(orderId!);
      setOrderDetail(order);
      console.log(order);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (!orderId) return;
    getOrderDetail();
    const timer = setInterval(async () => {
      getOrderDetail();
    }, 3000);
    return () => {
      clearInterval(timer);
    };
  }, [orderId]);

  return (
    <Flex
      sx={{
        width: "100%",
        minHeight: "100%",
        backgroundImage: `url(${BgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        padding: "20px",
      }}
      flexDir={"column"}
      alignItems={"center"}
    >
      <TitleHeader
        onBack={() => navigate("/")}
        title="Receipt"
        color="#D8762B"
        showSwitch={true}
      />
      <Flex
        sx={{
          width: "247px",
          background: `url(${ReceiptTop})`,
          backgroundSize: "100%",
          backgroundPosition: "0 0",
          backgroundRepeat: "no-repeat",
          marginTop: "30px",
          padding: "9px 7px 0",
        }}
        flexDir={"column"}
      >
        <Flex
          sx={{
            width: "100%",
            backgroundColor: `#FFFFFF`,
            minHeight: "300px",
            color: "#333",
            padding: "30px 20px 10px",
          }}
          flexDir={"column"}
          align={"center"}
        >
          <Text
            sx={{
              fontSize: "40px",
              fontWeight: 900,
            }}
          >
            -
            {formatAmount(
              usdToCurrency(orderDetail?.recipientAmount ?? "0"),
              usdcInfo.decimals
            )}
          </Text>
          <Text
            sx={{
              color: "#333",
              fontSize: "24px",
              fontWeight: 500,
            }}
          >
            {currencyUnit}
          </Text>

          <Flex
            sx={{
              width: "100%",
              marginTop: "22px",
              borderBottom: "1px dashed #848484",
              paddingBottom: "20px",
              position: "relative",
            }}
            flexDir={"column"}
          >
            <Text
              sx={{
                color: "#848484",
                fontSize: "14px",
                fontWeight: 700,
              }}
            >
              Withdraw To
            </Text>
            <Flex
              sx={{
                marginTop: "10px",
              }}
              align={"center"}
            >
              <Text
                sx={{
                  fontSize: "20px",
                  marginRight: "10px",
                }}
              >
                {unknownEmoji}
              </Text>
              <Box>
                <Text
                  sx={{
                    color: "#333",
                    fontSize: "12px",
                    fontWeight: 500,
                  }}
                >
                  {shortenAddress(orderDetail?.recipient?.address || "")}
                </Text>
              </Box>
            </Flex>
          </Flex>
          <Flex
            sx={{
              marginTop: "15px",
              width: "100%",
            }}
            justify={"space-between"}
          >
            <Text
              sx={{
                fontSize: "14px",
                fontWeight: 500,
                color: "#848484",
              }}
            >
              Time
            </Text>
            <Box
              sx={{
                textAlign: "right",
              }}
            >
              <Text
                sx={{
                  color: "#333",
                  fontSize: "14px",
                }}
              >
                {dayjs(orderDetail?.updatedAt).format("YYYY/MM/DD HH:mm")}
              </Text>
              <Text
                sx={{
                  color: "#848484",
                  fontSize: "12px",
                  fontWeight: 400,
                  fontFamily: "DIN-LightItalic",
                  marginTop: "4px",
                  fontStyle: "italic",
                }}
              >
                {dayjs(orderDetail?.updatedAt).fromNow()}
              </Text>{" "}
              <Text
                sx={{
                  color: isConfirmed ? "#00B327" : "#848484",
                  fontSize: "12px",
                  fontWeight: 500,
                  width: "100%",
                  marginTop: "4px",
                }}
              >
                {isConfirmed ? "Confirmed" : "Pending"}
              </Text>
            </Box>
          </Flex>
        </Flex>
        <Image
          src={ReceiptBottom}
          sx={{
            width: "100%",
          }}
        ></Image>
      </Flex>
    </Flex>
  );
};

export default WithdrawReceipt;
